module.exports = __webpack_public_path__ + "static/media/google-app.5c2a8d82.svg";